<div class="viewer-label">
  <span>{{ label | translate }}</span>
</div>
